export const gtmCancellationReasonEvent = (reason: string, locale?: string, userId?: number) => ({
  event: 'op-subscription-cancel',
  reason,
  locale,
  userId,
});

export default gtmCancellationReasonEvent;
